import axios from 'axios'
import {createAsyncThunk, PayloadAction, createAction, Action} from '@reduxjs/toolkit'
import { sliceStateStatus, systemStatus } from '../../../../Core';
import {routesIndex} from '@/RoutesIndex';

import ISliceState from '@/interface/core/ISliceState';
import { generateAssociationStateDataItem, generateAuthStateDataItem, generatePaginationStateDataItem } from '../../../hooks';
import IAssociation from '@/interface/IAssociation';
import IPagination from '@/interface/core/IPagination';
import { IType } from '@/interface/IType';

export const associationsIndex = createAsyncThunk(
  'associations/index',
  async (_, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      };

      let uri = routesIndex.api.prefix + routesIndex.api.associations + routesIndex.api.methods.index;

      const q = axios.get(
        uri, 
        config
      );
      const r = (await q).data;

      return setStateData(r);
    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const associationPaginate = createAsyncThunk (
  'association/paginate',
  async (_data:any, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
      }

      let uri = routesIndex.api.prefix + routesIndex.api.associations + routesIndex.api.methods.paginate;

      if(_data!.page && parseInt(_data!.page) > 1) {
        uri += '?page='+_data!.page;
      }

      const q = axios.post(
        uri, 
        _data,
        config
      );
      const r = (await q).data;
      
      return setStateData(r, true);
    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
);

export const associationStore = createAsyncThunk(
  'associations/store',
  async (_data:IAssociation, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      };

      const uri = routesIndex.api.prefix + routesIndex.api.associations + routesIndex.api.methods.store;

      const response = await axios.post(
        uri, 
        _data, 
        config
      );
      return setStateData(response.data);
      
    }

    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const associationUpdate = createAsyncThunk(
  'associations/update',
  async (_data:IAssociation, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      };

      const uri = routesIndex.api.prefix + routesIndex.api.associations + routesIndex.api.methods.update;

      const response = await axios.put(
        uri, 
        _data, 
        config
      );

      return setStateData(response.data); 

    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const associationDestroy = createAsyncThunk(
  'associations/destroy',
  async (_data: IAssociation, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        data: {
          id: _data.id,
          deleted_by: _data.deleted_by,
        }
      };

      const uri = routesIndex.api.prefix + routesIndex.api.associations + routesIndex.api.methods.destroy;

      const q = axios.delete(uri, config);
      const r = (await q).data;

      return setStateData(r);

    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const associationView = createAsyncThunk(
  'associations/view',
  async (id: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      };

      const uri = routesIndex.api.prefix + routesIndex.api.associations + routesIndex.api.methods.view + '/' + id;

      const response = await axios.get(uri, config);

      return setStateData(response.data); 
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);



const setStateData = (apiResponse: any, paginate: boolean = false) => {

  let stateData: ISliceState = {
    data: new Array<IAssociation>(),
    status: sliceStateStatus.fulfilled
  };

  if(apiResponse.status && apiResponse.result) {

    if(paginate) {
      stateData.data = {} as IPagination;
      Object.assign(stateData.data, generatePaginationStateDataItem(apiResponse.result, IType.association));
    }
    else {
      if(Array.isArray(apiResponse.result)) {
        apiResponse.result.map((a: any, i: number) => (
          stateData.data.push(
            generateAssociationStateDataItem(a)
          )
        ))
      }
      else {
        stateData.data = {} as IAssociation;
        Object.assign(stateData.data, generateAssociationStateDataItem(apiResponse.result));
      } 
    }
  }
  
  return stateData;
};